module.exports = __webpack_public_path__ + "static/media/bo.7bc1a10f.svg";